<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" type="danger" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button>
          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData" v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <el-button v-loading="totalOrders" :disabled="totalOrders" type="primary" v-if="tableAcl.indexOf('ToOrder') != -1 " class="btn primary" @click="toOrder">汇总生成订单</el-button>
          <BatchApproval v-if="tableAcl.indexOf('BatchApproves') != -1 "  :multipleSelectionList="multipleSelection" :batchApproval="batchApproval" @getData="getData" @reset="reset"/>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
           <div style="margin-right: 10px">
            排序方式 ：
            <el-select v-model="query.sortType" placeholder="请选择" @change="queryChange">
            <el-option label="创建时间" :value="1"></el-option>
            <el-option label="生效时间" :value="3"></el-option>
          </el-select>
          </div>
          <el-button class="btn primary" type="primary" style="margin-right: 10px;" @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>
      <div v-if="tableHaeder.length>0">

        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
          <template slot="before">
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
          </template>
          <template slot="after">
            <el-table-column prop="operation" fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
                <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
                <el-button v-else-if="
                    scope.row.status != 1 &&
                    scope.row.status != 2 &&
                    tableAcl.indexOf('Edit') != -1
                  " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
                <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
                <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
                <el-button type="text" class="margin-left20 color-blue" @click="handleCopy(scope.row)" v-if="
                    tableAcl.indexOf('Copy') != -1 ">复制</el-button>
                <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
  <div v-else>
    <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
      <template slot="empty">
        <div class="empty-div" :style="{ height: tableHeight + 'px' }">
          <img src="../../../../assets/noData.png" width="240" height="240" />
          <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
          <div class="empty-rest" @click="reset">恢复默认</div>
        </div>
      </template>
      <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
      </el-table-column>
      <el-table-column prop="no" width="175" label="计划单号">
        <template slot-scope="scope">
          <span>
            <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="pressingStateName" width="80" label="紧急标识">
        <template slot-scope="scope">
          <span :class="getPressingStateClass(scope.row.pressingState)">{{
            scope.row.pressingStateName
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="categoryName" width="120" label="采购类型">
      </el-table-column>
      <el-table-column width="160" label="完成情况">
        <template slot-scope="scope">
          <el-progress :text-inside="true" :stroke-width="20" :percentage="
              getPercentage(scope.row.totalInStockNumber, scope.row.totalNumber)
            " color="#42b983" />
        </template>
      </el-table-column>

      <el-table-column width="120" prop="isCreatedOrderName" label="已转订单"></el-table-column>
      <el-table-column width="120" prop="deptName" label="需求科室"></el-table-column>
      <el-table-column width="120" prop="createdUserName" label="发起人"></el-table-column>
      <el-table-column width="120" prop="ownerDeptName" label="所属科室"></el-table-column>
      <el-table-column width="170" prop="createdTime" label="创建时间">
        <template slot-scope="scope">
          {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
        </template>
      </el-table-column>
      <el-table-column width="170" prop="effectiveTime" label="生效时间">
        <template slot-scope="scope">
          {{
            parseTime(new Date(scope.row.effectiveTime), "{y}-{m}-{d} {h}:{i}:{s}")
          }}
        </template>
      </el-table-column>
      <el-table-column width="120" prop="deliveryTime" label="要求送达日期">
        <template slot-scope="scope">{{
          parseTime(new Date(scope.row.deliveryTime), "{y}-{m}-{d}")
        }}</template>
      </el-table-column>
      <el-table-column width="120" prop="totalNumber" label="总数量"></el-table-column>
      <el-table-column width="120" prop="totalAmount" label="总金额"></el-table-column>
      <el-table-column label="审批人" width="100" align="center" prop="approverNames">
        <template slot-scope="scope">
          <span>{{ scope.row.approverNames?scope.row.approverNames:'-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="statusName" label="流程状态" width="80" >
        <template slot-scope="scope">
          <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.remark?scope.row.remark:'-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="oneLevelWarehouseName" label="收货库房" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="operation" fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
          <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
          <el-button v-else-if="
              scope.row.status != 1 &&
              scope.row.status != 2 &&
              tableAcl.indexOf('Edit') != -1
            " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
          <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
          <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
          <el-button type="text" class="margin-left20 color-blue" @click="handleCopy(scope.row)" v-if="
              tableAcl.indexOf('Copy') != -1 ">复制</el-button>
          <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
        </template>
      </el-table-column>
    </el-table>
  </div>

      <!-- <info :show="showInfo" :id="id" @handleClose="closeInfo"></info> -->
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer  ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import {
  SpdRemovePurchasePlan,
  SpdGetPurchasePlans,
  SpdExportPurchasePlan,
  CreatePurchaseOrderByPlanIds,
  ApprovePurchasePlans
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import BaseListMixin from "@/mixin/baseList-mixin.js";
// import Info from './info';
import {
  WhetherOptions,
  PlanStateOptions,
  ApproveStatusOptions,
  PurchaseCategoryOptions
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BatchApproval from "@/components/batchApproval";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
    BatchApproval,
  },
  data () {
    return {
      exportAction: SpdExportPurchasePlan,
      batchApproval:ApprovePurchasePlans,
      GetDatasAction: SpdGetPurchasePlans,
      RemoveAction: SpdRemovePurchasePlan,
      editPath: "spd-purchase-plan-edit",
      PurchaseCategoryOptions: PurchaseCategoryOptions,
      // 查询条件
      // query: {
      //   keyWord: "",
      //   pageSize: 10,
      //   pageIndex: 1,
      // },
      // // 列表数据
      // tableData: [],
      // // 列表总数
      // total: 0,
      // // 弹出框标题
      // title: "",
      // // 弹出编辑框
      // open: false,
      // // 打开详情
      // showInfo: false,
      // id: 0,
      // // 多选框数据
      // ids: [],
      // multipleSelection: [],
      // // 列表多选
      // multiple: true,
      totalOrders:false,
      WhetherOptions: WhetherOptions,
      PlanStateOptions: PlanStateOptions,
      ApproveStatusOptions: ApproveStatusOptions,
      filterOptions: [{
        name: "单号",
        type: "input",
        code: "keyWord",
      },
      {
        name: "供应商产品编码",
        type: "input",
        code: "supplierProductNo",
      },
      {
        name: "产品名称",
        type: "input",
        code: "productName",
      },
      {
        name: "规格型号",
        type: "input",
        code: "specName",
      },
      {
        name: "生产厂家",
        type: "select",
        code: "manufacturerId",
        filterMethod: this.getManufacturers,
        data: [],
      },
      {
        name: "供应商",
        type: "select",
        code: "supplierId",
        filterMethod: this.getSuppliers,
        data: [],
      },
      {
        name: "供货商产品",
        type: "select",
        code: "supplierProductId",
        filterMethod: this.getSupplierProductsNoDebounce1,
        data: [],
      },
      {
        name: "所属科室",
        type: "select",
        code: "ownerDeptid",
        filterMethod: this.getDepts,
        data: [],
      },
      {
        name: "审批人",
        type: "select",
        code: "approveId",
        filterMethod: this.getApproves,
        data: [],
      },
      {
        name: "流程状态",
        type: "select",
        code: "statuses",
        multiple: true,
        data: ApproveStatusOptions,
      },
      {
        name: "日期范围",
        type: "date",
        code: "date",
      },
      {
        name: "是否已生成订单",
        type: "select",
        code: "isCreatedOrder",
        data: WhetherOptions,
        // defaultValue: 0,
      },
      // 需求科室
      {
        name: "需求科室",
        type: "select",
        code: "deptId",
        filterMethod: this.getDepts,
        data: [],
      },
      {
        name: "主条码",
        type: "input",
        code: "mainNo",
      },
          {
          name: "采购类型",
          type: "select",
          code: "categorys",
          data: PurchaseCategoryOptions,
          multiple: true,
        },
         {
            name: "二级供应商",
            type: "input",
            code: "secondSupplierName",
        },
      ],
    };
  },
  methods: {
    toOrder () {
      const length = this.ids.length;
      if (length === 0) {
        this.$my_message(`请选择数据`, "warning");
        return;
      }
      if (this.system_setting.AutoGeneratePoFromPp == 1) {
        this.$my_message(`不支持手动汇总、当前启用采购计划审批通过自动生成采购订单`, "warning");
        return;
      }


      let statusDatas = this.multipleSelection.filter((e) => e.status != 2);
      if (statusDatas != null && statusDatas.length > 0) {
        this.$my_message(`存在不是生效状态的数据，请重新勾选`, "warning");
        return;
      }
      let stateDatas = this.multipleSelection.filter((e) => e.isCreatedOrder == 1);
      if (stateDatas != null && stateDatas.length > 0) {
        this.$my_message(`存在已生成采购订单的计划，请重新勾选`, "warning");
        return;
      }

      let oneLevelWarehouseIds = Array.from(new Set(this.multipleSelection.map((e) => e.oneLevelWarehouseId)));
      if (oneLevelWarehouseIds != null && oneLevelWarehouseIds.length > 1) {
        this.$my_message(`所选数据存在收货库房不一致，请重新勾选`, "warning");
        return;
      }
     
      // console.log(this.multipleSelection);
      
      // return


      // const h = this.$createElement;
      // let content = [h("p", "确定要生成采购订单吗？")];
      // let otherOneLevelWarehouseIds = this.multipleSelection.filter(
      //   (e) => e.warehouseId != this.multipleSelection[0].warehouseId
      // );
      // if (otherOneLevelWarehouseIds && otherOneLevelWarehouseIds.length > 0) {
      //   // message += "<br/><span style='color:red'>存在目标库房不一致</span>";
      //   content.push(
      //     h(
      //       "p",
      //       {
      //         style: "color:red",
      //       },
      //       "所选计划需求库房不一致，是否继续？"
      //     )
      //   );
      // }

      // this.$confirm("提示", {
      //   title: "提示",
      //   type: "warning",
      //   message: h("div", content),
      // }).then(() => {
        let show = false
        
        this.multipleSelection.forEach(e=>{
          if(this.multipleSelection[0].deptId != e.deptId){
            show = true
          }
        })

        if(show){
          this.$confirm('所勾选计划存在不同的需求科室，若继续汇总转订单则订单的需求科室将默认为收货库房科室，是否继续？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(()=>{
            CreatePurchaseOrderByPlanIds({ ids: this.ids }).then(res => {
            if (!res.successful) {
              return;
            }
            this.$my_message(`生成成功`, "success");
            this.getData()
            this.ids = []
            this.$refs.multipleTable.clearSelection();
          })
          }).catch(()=>{
          })
        }else{
          this.totalOrders = true
          CreatePurchaseOrderByPlanIds({ ids: this.ids }).then(res => {
            if (!res.returnData.successful) {
              this.$my_message(res.returnData.errorMessage, "warning");
              this.totalOrders =false
              return;
            }
            this.$my_message(`生成成功`, "success");
            this.getData()
            this.ids = []
            this.$refs.multipleTable.clearSelection();
            this.totalOrders = false
          }).catch(()=>{
            this.totalOrders = false
          })
        }
        
      // });
    },

    // handleSelectionChange (selection) {
    //   this.multipleSelection = selection;
    //   this.ids = selection.map((item) => item.id);
    //   this.multiple = !selection.length;
    // },
    // // 获取列表
    // getData () {
    //   SpdGetPurchasePlans(this.query).then((res) => {
    //     this.tableData = res.returnData.data;
    //     this.total = res.returnData.totalCount;
    //   });
    // },
    // // 查看信息
    // handleInfo (row) {
    //   // this.$router.push("/spd-purchase-plan-edit?formMode=0&id=" + row.id);
    //   this.routePushWithParams("/spd-purchase-plan-edit", this.query, { formMode: 0, id: row.id });
    // },
    // // 新建
    // handleAdd () {
    //   // this.$router.push("/spd-purchase-plan-edit?formMode=1");
    //   this.routePushWithParams("/spd-purchase-plan-edit", this.query, { formMode: 1 });
    // },
    // // 编辑
    // handleUpdate (row) {
    //   // this.$router.push("/spd-purchase-plan-edit?formMode=2&id=" + row.id);
    //   this.routePushWithParams("/spd-purchase-plan-edit", this.query, { formMode: 2, id: row.id });
    // },
    // // 审批
    // handleApprove (row) {
    //   // this.$router.push("/spd-purchase-plan-edit?formMode=3&id=" + row.id);
    //   this.routePushWithParams("/spd-purchase-plan-edit", this.query, { formMode: 3, id: row.id });
    // },
    // // 改变当前页
    // changePage (val) {
    //   this.$set(this.query, "pageIndex", val);
    //   this.getData();
    // },
    // handleSizeChange (val) {
    //   this.$set(this.query, "pageSize", val);
    //   this.getData();
    // },
    // // 删除部门
    // handleDelete (row) {
    //   const ids = row && row.id ? [row.id] : this.ids;
    //   this.$my_confirm("此操作将删除数据，是否继续？", "提示", {
    //     type: "warning",
    //   })
    //     .then(() => {
    //       return SpdRemovePurchasePlan({ ids });
    //     })
    //     .then(() => {
    //       this.$my_message(`操作成功！`, "success");
    //       this.getData();
    //     })
    //     .catch(() => { });
    // },
    // // 重置
    // reset () {
    //   this.query = {
    //     keyWord: "",
    //     pageSize: 10,
    //     pageIndex: 1,
    //   };
    //   if (this.$refs["selectFilter"]) {
    //     this.$refs["selectFilter"].resetQuery();
    //   }
    //   this.ids = []
    //   this.multipleSelection = []
    //   this.multiple = true;
    //   if (this.$refs.multipleTable) {
    //     this.$refs.multipleTable.clearSelection()
    //   }
    //   this.getData();
    // },
    // queryChange () {
    //   this.$set(this.query, "pageIndex", 1);
    //   this.getData();
    // },
    // filterChange (query) {
    //   this.query = Object.assign(this.query, query);
    //   this.getData();
    // },
    handleCopy (row) {
      this.routePushWithParams("/spd-purchase-plan-edit", this.query, {
        formMode: 2,
        id: row.id,
        isCopy: 1,
      });
    },
  },
  created () {
   
    // this.reset()
    // console.log(this.$store.getters);
    // 分页组件默认值需要早created
    // if (this.$route.params) {
    //   this.query = this.$route.params
    // }
  },
  mounted () {
    // 查询组件默认值需要在mounted
    // if (this.$route.params) {
    //   this.$refs["selectFilter"].query = this.query
    // }
    this.query.sortType = 1
    // this.getData();
    // this.getSupplierProductsNoDebounce1()
  },
};
</script>

<style lang="scss" scoped></style>
